import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { MoneyOff as RefundIcon } from '@mui/icons-material';

interface ActionButtonTemplateProps {
  encounterId: string;
  isCreating: boolean;
  onSelect: () => void;
}

/**
 * Action button for selecting encounter
 */
export const ActionButtonTemplate: React.FC<ActionButtonTemplateProps> = ({
  encounterId,
  isCreating,
  onSelect,
}) => (
  <Button
    variant="contained"
    size="small"
    startIcon={
      isCreating ? (
        <CircularProgress size={12} color="inherit" />
      ) : (
        <RefundIcon sx={{ fontSize: '1rem' }} />
      )
    }
    onClick={onSelect}
    disabled={isCreating}
    sx={{
      backgroundColor: '#162346',
      '&:hover': {
        backgroundColor: '#1a2a52',
      },
      fontWeight: 500,
      fontSize: '0.7rem',
      minWidth: '70px',
      height: '28px',
      px: 1,
    }}
  >
    {isCreating ? 'Creating...' : 'Select'}
  </Button>
);

export default ActionButtonTemplate;
